import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { Chip } from '@material-ui/core';

const styles = () => ({
  warning: {
    border: '1px solid #fc9403',
    color: '#fc9403',
    background: 'rgba(252, 148, 3, 0.07)',
  },
  success: {
    border: '1px solid #1aaa55',
    color: '#1aaa55',
    background: 'rgba(26, 170, 85, 0.07)',
  },
  error: {
    border: '1px solid #db3b21',
    color: '#db3b21',
    background: 'rgba(219, 59, 33, 0.07)',
  },
  chip: {
    borderRadius: '5px',
    height: '20px',
    fontSize: '11px',
  },
});

class StatusChip extends PureComponent {
  render() {
    const { type, classes, label, variant } = this.props;

    return (
      <Chip
        className={classNames(classes.chip, classes[type])}
        label={label}
        variant={variant}
      />
    );
  }
}

export default withStyles(styles)(StatusChip);

StatusChip.propTypes = {
  classes: PropTypes.object.isRequired,
  variant: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
};

StatusChip.defaultProps = {
  type: 'default',
  variant: 'default',
};



// WEBPACK FOOTER //
// ./src/components/StatusChip.js